import { useAuthStore } from "stores"
import { isDevelopment } from "./utils"

// Feature flag: client-side Customer.io tracking is disconnected by default.
// Analytics now flows through Conviso server-side (ewa-service / core-backend).
// Set REACT_APP_CUSTOMERIO_ENABLED="true" to re-enable the legacy path.
const isCustomerIOEnabled =
  process.env.REACT_APP_CUSTOMERIO_ENABLED === "true"

// Just a function - using cioanalytics instead of analytics
export const customerIOTrackEvent = (
  eventName: string,
  userId?: string,
  properties?: any
) => {
  if (!isCustomerIOEnabled) {
    return
  }
  const tryTrack = (attempts = 0) => {
    if (typeof window === "undefined") {
      console.warn("Customer.io: Not in browser environment")
      return
    }

    if (!window.cioanalytics) {
      if (attempts < 10) {
        setTimeout(() => tryTrack(attempts + 1), 500)
        return
      }
      console.warn("Customer.io: Analytics not loaded after 5 seconds")
      return
    }

    const user = useAuthStore.getState().user

    const finalUserId = userId || user?.userName

    const defaultProperties = {
      email: user?.userName,
      name: user?.userName,
      organization: user?.userOrganisation,
      organization_id: user?.userOrganisationId,
      is_admin: user?.isAdmin,
      channel: "Web",
    }

    const finalProperties = {
      ...defaultProperties,
      ...properties,
    }

    const cleanProperties = Object.fromEntries(
      Object.entries(finalProperties).filter(
        ([_, value]) => value !== undefined
      )
    )

    if (finalUserId) {
      window.cioanalytics.identify(finalUserId, cleanProperties)
    }

    window.cioanalytics.track(eventName, cleanProperties)
  }

  if (!isDevelopment) {
    tryTrack()
  }
}

declare global {
  interface Window {
    cioanalytics: any
  }
}
export {}
